import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $patchStyleText } from "@lexical/selection";
import { $getSelection, $isRangeSelection } from "lexical";

export default function FontFamilyPlugin() {
  const [editor] = useLexicalComposerContext();

  const applyFont = (family) => {
    editor.update(() => {
      const selection = $getSelection();
      if ($isRangeSelection(selection)) {
        $patchStyleText(selection, { "font-family": family });
      }
    });
  };

  return (
    <select
      onChange={(e) => applyFont(e.target.value)}
      style={{ padding: "4px", marginRight: "8px" }}
      defaultValue=""
    >
      <option value="" disabled>Font</option>
      <option value="Arial">Arial</option>
      <option value="Georgia">Georgia</option>
      <option value="Times New Roman">Times New Roman</option>
      <option value="Verdana">Verdana</option>
      <option value="Courier New">Courier New</option>
      <option value="Trebuchet MS">Trebuchet MS</option>
    </select>
  );
}
